
import {
    NOTIFICACIONESINDI_LOADING,
    NOTIFICACIONESINDI_LOADED,
    NOTIFICACIONESINDI_ERROR,

    NOTIFICACIONES_LOADING,
    NOTIFICACIONES_LOADED,
    NOTIFICACIONES_ERROR,
    
    CREARNOTIFICACION_ERROR,
    CREARNOTIFICACION_LOADED,
    CREARNOTIFICACION_LOADING,
    
    EDITARNOTIFICACION_ERROR,
    EDITARNOTIFICACION_LOADED,
    EDITARNOTIFICACION_LOADING,
    
    DELETENOTIFICACION_ERROR,
    DELETENOTIFICACION_LOADED,
    DELETENOTIFICACION_LOADING
  } from './../../types/notificacionestypes';

const INITIAL_STATE = {
    isLoading: false,
    notificacion: [],
    notiindi: [],
    noticrea : [],
    error: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case NOTIFICACIONESINDI_LOADING:
            return {
                ... state,
                isLoading : true,
                notiindi: [],
                error: ''
            }
        case NOTIFICACIONESINDI_LOADED:
            return {
                ...state,
                notiindi: action.payload,
                error: '',
                isLoading: false
            };
        case NOTIFICACIONESINDI_ERROR:
            return {
                ...state,
                notiindi: [],
                isLoading: false,
                error: action.payload,
            }

        case NOTIFICACIONES_LOADING:
            return {
                ... state,
                isLoading : true,
                notificacion: [],
                error: ''
            }
        case NOTIFICACIONES_LOADED:
            return {
                ...state,
                notificacion: action.payload,
                error: '',
                isLoading: false
            };
        case NOTIFICACIONES_ERROR:
            return {
                ...state,
                notificacion: [],
                isLoading: false,
                error: action.payload,
            }


        case CREARNOTIFICACION_LOADING:
            return {
                ... state,
                isLoading : true,
                noticrea : [],
                error: ''
            }
        case CREARNOTIFICACION_LOADED:
            return {
                ... state,
                isLoading : false,
                noticrea: action.payload,
                error: ''
            };
        case CREARNOTIFICACION_ERROR:
            return {
                ...state,
                noticrea : [],
                isLoading : false,
                error: action.payload,
            }

        case EDITARNOTIFICACION_LOADING:
            return {
                ... state,
                isLoading : true,
                noticrea : [],
                error: ''
            }
        case EDITARNOTIFICACION_LOADED:
            return {
                ... state,
                isLoading : false,
                noticrea: action.payload,
                error: ''
            };
        case EDITARNOTIFICACION_ERROR:
            return {
                ...state,
                noticrea : [],
                isLoading : false,
                error: action.payload,
            }

        case DELETENOTIFICACION_LOADING:
            return {
                ... state,
                isLoading : true,
                noticrea : [],
                error: ''
            }
        case DELETENOTIFICACION_LOADED:
            return {
                ... state,
                isLoading : false,
                noticrea: action.payload,
                error: ''
            };
        case DELETENOTIFICACION_ERROR:
            return {
                ...state,
                noticrea : [],
                isLoading : false,
                error: action.payload,
            }
        default: return state;
    }
}